import { z } from 'zod';
import { ControlVariableDataType } from 'libs/end-to-end/src/types/databases/controls/control-variable-data-type';
import { ControlVariableTransformationType } from 'libs/end-to-end/src/types/databases/controls/control-variable-transformation-type';
import { ControlVariablePlaceToHideValue } from 'libs/end-to-end/src/types/databases/controls/control-variable-places-to-hide';

export const NumericalTraitDefinition = z
  .object({
    /**
     * @example 'year' or 'month'
     */
    unitSingular: z.string().min(1),
    /**
     * @example 'years' or 'months'
     */
    unitPlural: z.string().min(1),
    /**
     * The lowest value the trait can have
     * @example 1 // Will only show whole numbers
     * @example .5 // Will only show numbers divisible by .5
     */
    denominator: z.number().positive(),
  })
  .describe('NumericalTraitDefinition');

export type NumericalTraitDefinition = z.infer<typeof NumericalTraitDefinition>;

export const CategoricalTraitDefinition = z
  .object({
    sortOrder: z.array(z.string()).optional(),
  })
  .describe('CategoricalTraitDefinition');

export type CategoricalTraitDefinition = z.infer<
  typeof CategoricalTraitDefinition
>;

export const ControlVariableDefinition = z
  .object({
    columnHeaderValue: z.string(),
    displayName: z.string(),
    dataType: ControlVariableDataType,
    transformationType: ControlVariableTransformationType,
    numericalTraitDefinition: NumericalTraitDefinition.optional(),
    categoricalTraitDefinition: CategoricalTraitDefinition.optional(),
    description: z.string().optional(),
    placesToHide: z.array(ControlVariablePlaceToHideValue).optional(),
  })
  .describe('ControlVariableDefinition');

export type ControlVariableDefinition = z.infer<
  typeof ControlVariableDefinition
>;
